export default function () {
  return {
    timeout: 0,
    kind: '', // positive, negative, warning, accent, info, <any color>, <any color>-<1-9>
    messages: '',
    pageSpecific: false,
    visible: false
  }
}
